import { render, staticRenderFns } from "./ReviewYourAnswersNDT.vue?vue&type=template&id=198c6e96"
import script from "./ReviewYourAnswersNDT.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersNDT.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports